import React from 'react';

const ResultCard = ({ url }) => {
  return (
    <div className="resultCard">
      <img className="resultImg" src={url} alt="tweet" />
      <a href={url}>
        <div className="enlargeBtn">
          <i className="fas fa-search-plus fa-2x enlargeIcon"></i>
        </div>
      </a>
    </div>
  );
};

export default ResultCard;